export const RATING_TYPE_Q = [
  "indicator", //индикатор
  "Title", // заголовок
  "SubTitle", // под-заголовок
  "header", // заголвие
];
export const REQUIRED_INDICATORS_INPUT_Q = [
  "KPIru", //индикатор
  "KPIen", // заголовок
  "sort", // под-заголовок
];
